function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.querySelector('.announcement-bar-slider')) {
      this.announcementBarArrowButtonWasClicked = false;

      this.desktopLayout = window.matchMedia('(min-width: 750px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      [this.reducedMotion, this.desktopLayout].forEach((mediaQuery) => {
        mediaQuery.addEventListener('change', () => {
          if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
        });
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener('click', () => {
          this.announcementBarArrowButtonWasClicked = true;
        }, {once: true});
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked || !this.desktopLayout.matches ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked && this.desktopLayout.matches) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.querySelector('.announcement-bar-slider').contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

/* Sticky mobile Add-to-Cart bar
   - Shows once the main product form scrolls out of view
   - Tapping the button scrolls to the main product form and pulses the real ATC
   - Updates price live when the variant changes
*/
(function () {
  if (typeof window === 'undefined') return;

  const bar = document.querySelector('[data-sticky-atc]');
  if (!bar) return;

  const trigger = bar.querySelector('[data-sticky-atc-trigger]');
  const priceEl = bar.querySelector('[data-sticky-atc-price]');
  const buttonEl = bar.querySelector('[data-sticky-atc-button]');

  // The main product form / ATC we want to reveal
  const mainForm =
    document.querySelector('product-form form, form[action*="/cart/add"]') || null;
  const mainAtc =
    document.querySelector('product-form [name="add"], button[name="add"]') || null;

  if (!mainForm) return;

  // ---- Visibility: show sticky bar after main ATC scrolls out of view ----
  let visible = false;
  const setVisible = (v) => {
    if (v === visible) return;
    visible = v;
    bar.classList.toggle('is-visible', v);
    bar.setAttribute('aria-hidden', v ? 'false' : 'true');
  };

  const observerTarget = mainAtc || mainForm;
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // Show bar when the main ATC is NOT visible
          setVisible(!entry.isIntersecting);
        });
      },
      { root: null, threshold: 0, rootMargin: '0px 0px -60px 0px' }
    );
    io.observe(observerTarget);
  } else {
    // Fallback: show after 400px scroll
    window.addEventListener(
      'scroll',
      () => setVisible(window.scrollY > 400),
      { passive: true }
    );
  }

    // ---- Tap → scroll to variant selection / customization fields ----
  const scrollToMain = (e) => {
    e.preventDefault();

    // Priority: product personalizer (custom fields like Highway Carrier Code)
    //   → variant selectors → product form → ATC button as last resort
    const target =
      document.querySelector('.product-personalizer') ||
      document.querySelector('[id^="pplr-"]') ||
      document.querySelector('variant-selects') ||
      document.querySelector('variant-radios') ||
      document.querySelector('.product-form__input') ||
      mainForm ||
      mainAtc;

    if (!target) return;

    const rect = target.getBoundingClientRect();
    const top = rect.top + window.pageYOffset - 100;
    window.scrollTo({ top, behavior: 'smooth' });

    // After scroll settles, flash the target and focus the first empty input
    window.setTimeout(() => {
      target.classList.add('sticky-atc-target-flash');

      const firstInput = target.querySelector(
        'input:not([type="hidden"]):not([disabled]):not([readonly]), select:not([disabled]), textarea:not([disabled])'
      );
      if (firstInput) {
        try { firstInput.focus({ preventScroll: true }); } catch (_) {}
      }

      window.setTimeout(
        () => target.classList.remove('sticky-atc-target-flash'),
        1300
      );
    }, 450);
  };
  trigger.addEventListener('click', scrollToMain);

  // ---- Keep price + availability in sync with variant changes ----
  const money = (cents) => {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  };

  const updateFromVariant = (variant) => {
    if (!variant) return;

    // Price
    if (priceEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceEl.innerHTML =
          '<span class="sticky-atc-mobile__price-sale">' +
            money(variant.price) +
          '</span>' +
          '<s class="sticky-atc-mobile__price-compare">' +
            money(variant.compare_at_price) +
          '</s>';
      } else {
        priceEl.textContent = money(variant.price);
      }
    }

    // Availability
    if (buttonEl) {
      if (variant.available) {
        buttonEl.textContent =
          (window.theme && window.theme.strings && window.theme.strings.addToCart) ||
          'Add to cart';
        buttonEl.classList.remove('sticky-atc-mobile__button--sold-out');
      } else {
        buttonEl.textContent =
          (window.theme && window.theme.strings && window.theme.strings.soldOut) ||
          'Sold out';
        buttonEl.classList.add('sticky-atc-mobile__button--sold-out');
      }
    }
  };

  // Dawn dispatches a "variant:change" event on the <variant-selects> element
  document.addEventListener('variant:change', (e) => {
    if (e && e.detail && e.detail.variant) updateFromVariant(e.detail.variant);
  });

  // Fallback: watch the variant ID hidden input
  const variantInput = mainForm.querySelector('[name="id"]');
  if (variantInput && window.MutationObserver) {
    const mo = new MutationObserver(() => {
      const id = parseInt(variantInput.value, 10);
      if (!id || !window.productVariants) return;
      const v = window.productVariants.find((x) => x.id === id);
      if (v) updateFromVariant(v);
    });
    mo.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
  }
})();

/* ==========================================================================
   Cart Discount Form — background apply via hidden iframe, no visible reload,
   strict post-apply validation, inline cart re-render.
   ========================================================================== */
(function () {
  if (typeof window === 'undefined') return;

  const form = document.querySelector('[data-discount-form]');
  if (!form) return;

  const input = form.querySelector('[data-discount-input]');
  const button = form.querySelector('[data-discount-submit]');
  const message = form.querySelector('[data-discount-message]');

  function showMessage(text, kind) {
    if (!message) return;
    message.textContent = text;
    message.className = 'cart-discount__message is-' + kind;
  }

  function openDetails() {
    const details = form.closest('details');
    if (details) details.open = true;
  }

  function resetButton(label) {
    button.disabled = false;
    button.textContent = label || 'Apply';
  }

  function showExistingDiscountConfirmation() {
    const freshForm = document.querySelector('[data-discount-form]');
    const freshMessage = freshForm && freshForm.querySelector('[data-discount-message]');
    if (!freshForm || !freshMessage) return;

    fetch(`${window.Shopify.routes.root}cart.js`)
      .then((r) => r.json())
      .then((cart) => {
        // Collect every applied code + its savings
        const applied = [];
        (cart.cart_level_discount_applications || []).forEach((d) => {
          if (d.title) applied.push({ title: d.title, cents: d.total_allocated_amount || 0 });
        });
        (cart.items || []).forEach((item) => {
          (item.discounts || []).forEach((d) => {
            if (!d.title) return;
            const existing = applied.find((a) => normalize(a.title) === normalize(d.title));
            if (existing) existing.cents += d.amount || 0;
            else applied.push({ title: d.title, cents: d.amount || 0 });
          });
        });

        if (!applied.length) return;

        const freshDetails = freshForm.closest('details');
        if (freshDetails) freshDetails.open = true;

        const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
        freshMessage.className = 'cart-discount__message is-success';
        freshMessage.innerHTML = '';

        applied.forEach(({ title, cents }) => {
          const saved = (cents / 100).toLocaleString('en-US', { style: 'currency', currency });
          const row = document.createElement('div');
          row.className = 'cart-discount__applied-row';
          row.innerHTML =
            `<span class="cart-discount__applied-text">Code “${title.toUpperCase()}” applied — you saved ${saved}.</span>` +
            `<button type="button" class="cart-discount__remove" data-discount-remove="${title.toUpperCase()}" aria-label="Remove promo code ${title.toUpperCase()}">Remove</button>`;
          freshMessage.appendChild(row);
        });
      })
      .catch(() => { /* non-fatal */ });
  }

  function normalize(s) {
    return (s || '').toString().trim().toUpperCase();
  }

  function refreshCartSections() {
    const itemsEl = document.querySelector('#main-cart-items');
    const footerEl = document.querySelector('#main-cart-footer');
    const iconEl = document.querySelector('#cart-icon-bubble');
    const sections = [];
    if (itemsEl && itemsEl.dataset.id)  sections.push({ id: 'main-cart-items',  section: itemsEl.dataset.id,  selector: '.js-contents' });
    if (footerEl && footerEl.dataset.id) sections.push({ id: 'main-cart-footer', section: footerEl.dataset.id, selector: '.js-contents' });
    if (iconEl) sections.push({ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });

    if (!sections.length) return Promise.resolve();

    return fetch(`${window.Shopify.routes.root}?sections=${sections.map((s) => s.section).join(',')}`)
      .then((r) => r.json())
      .then((data) => {
        sections.forEach(({ id, section, selector }) => {
          const container = document.getElementById(id);
          if (!container || !data[section]) return;
          const doc = new DOMParser().parseFromString(data[section], 'text/html');
          const targetInner = container.querySelector(selector);
          const newInner = doc.querySelector(selector);
          if (targetInner && newInner) targetInner.innerHTML = newInner.innerHTML;
        });
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'discount-form' });
        }
      })
      .catch(() => { /* non-fatal */ });
  }

  function snapshotCart() {
    return fetch(`${window.Shopify.routes.root}cart.js`).then((r) => r.json());
  }

  function applyViaIframe(code) {
    return new Promise((resolve, reject) => {
      // Cleanup any prior iframe
      const prior = document.getElementById('bp-discount-frame');
      if (prior) prior.remove();

      const iframe = document.createElement('iframe');
      iframe.id = 'bp-discount-frame';
      iframe.setAttribute('aria-hidden', 'true');
      iframe.style.cssText = 'position:absolute;width:1px;height:1px;left:-9999px;top:-9999px;border:0;';
      document.body.appendChild(iframe);

      let done = false;
      const finish = (ok) => {
        if (done) return;
        done = true;
        setTimeout(() => { try { iframe.remove(); } catch (_) {} }, 250);
        ok ? resolve() : reject(new Error('iframe load timeout'));
      };

      iframe.addEventListener('load', () => finish(true), { once: true });
      // Fallback timeout in case the iframe is blocked
      setTimeout(() => finish(true), 8000);

      // /discount/CODE?redirect=/cart sets the code on the session, then bounces to /cart
      iframe.src = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
    });
  }

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    e.stopPropagation();

    const code = (input.value || '').trim();
    if (!code) {
      showMessage('Please enter a promo code.', 'error');
      openDetails();
      input.focus();
      return;
    }

    showMessage('Applying code...', 'loading');
    openDetails();
    button.disabled = true;
    button.textContent = 'Applying';

    let beforeTotal = 0;
    let beforeTitles = [];

    snapshotCart()
      .then((cart) => {
        beforeTotal = cart.total_price || 0;
        const cartLevel = (cart.cart_level_discount_applications || []).map((d) => normalize(d.title));
        const lineLevel = (cart.items || []).flatMap((i) => (i.discounts || []).map((d) => normalize(d.title)));
        beforeTitles = cartLevel.concat(lineLevel);
      })
      .then(() => applyViaIframe(code))
      .then(() => snapshotCart())
      .then((cartAfter) => {
        const codeUpper = normalize(code);
        const cartLevel = (cartAfter.cart_level_discount_applications || []).map((d) => normalize(d.title));
        const lineLevel = (cartAfter.items || []).flatMap((i) => (i.discounts || []).map((d) => normalize(d.title)));
        const afterTitles = cartLevel.concat(lineLevel);

        // "Applied" = a discount whose title matches the entered code appears
        // AND it wasn't already there before (so we don't credit pre-existing discounts).
        const matchedNow = afterTitles.includes(codeUpper);
        const matchedBefore = beforeTitles.includes(codeUpper);
        const totalDropped = (cartAfter.total_price || 0) < beforeTotal;

        const applied = (matchedNow && !matchedBefore) || (matchedNow && totalDropped);

        if (applied) {
          // Compute savings amount from the matching discount
          let savedCents = 0;
          (cartAfter.cart_level_discount_applications || []).forEach((d) => {
            if (normalize(d.title) === codeUpper) {
              savedCents += d.total_allocated_amount || 0;
            }
          });
          (cartAfter.items || []).forEach((item) => {
            (item.discounts || []).forEach((d) => {
              if (normalize(d.title) === codeUpper) {
                savedCents += d.amount || 0;
              }
            });
          });
          if (!savedCents) {
            // Fallback: cart total delta
            savedCents = Math.max(0, beforeTotal - (cartAfter.total_price || 0));
          }

          const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
          const saved = (savedCents / 100).toLocaleString('en-US', { style: 'currency', currency });

          const successText = `Code “${code.toUpperCase()}” applied — you saved ${saved}.`;
          try { sessionStorage.setItem('bp_promo_applied_this_visit', '1'); } catch (_) {}
          resetButton();
          return refreshCartSections().then(() => {
            // Cart footer just re-rendered — old form/message nodes are stale.
            // Grab the fresh ones, re-open the details, restore the success message.
            const freshForm = document.querySelector('[data-discount-form]');
            const freshMessage = freshForm && freshForm.querySelector('[data-discount-message]');
            const freshInput = freshForm && freshForm.querySelector('[data-discount-input]');
            const freshDetails = freshForm && freshForm.closest('details');
            if (freshDetails) freshDetails.open = true;
            if (freshMessage) {
              freshMessage.textContent = successText;
              freshMessage.className = 'cart-discount__message is-success';
            }
            if (freshInput) freshInput.value = '';
          });
        }

        // Not applied → tell them clearly
        showMessage(`“${code}” isn’t a valid promo code.`, 'error');
        input.focus();
        input.select();
        resetButton();
      })
      .catch((err) => {
        console.error('[cart-discount] apply failed', err);
        showMessage(`Couldn’t apply “${code}”. Please try again.`, 'error');
        resetButton();
      });
  });

  showExistingDiscountConfirmation();

  // Delegated handler for Remove buttons — clears cart then re-adds items,
  // which is the only reliable way to kill Shopify's session-level discount.
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-discount-remove]');
    if (!btn) return;
    e.preventDefault();

    try { sessionStorage.removeItem('bp_promo_applied_this_visit'); } catch (_) {}

    btn.disabled = true;
    btn.textContent = 'Removing';

    const root = window.Shopify.routes.root;

    fetch(`${root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount_codes: [] })
    })
      .then((r) => r.json())
      .then(() => {
        // Pricing app owns visible prices; hard reload guarantees a clean re-render.
        window.location.href = '/cart';
      })
      .catch((err) => {
        console.error('[cart-discount] remove failed', err);
        const msg = document.querySelector('[data-discount-message]');
        if (msg) {
          msg.textContent = 'Couldn’t remove the code. Please refresh and try again.';
          msg.className = 'cart-discount__message is-error';
        }
        const stillBtn = document.querySelector('[data-discount-remove]');
        if (stillBtn) {
          stillBtn.disabled = false;
          stillBtn.textContent = 'Remove';
        }
      });
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      fetch(`${window.Shopify.routes.root}cart.js`)
        .then((r) => r.json())
        .then((cart) => {
          if (cart && cart.item_count === 0) {
            try { sessionStorage.removeItem('bp_promo_applied_this_visit'); } catch (_) {}
          }
        })
        .catch(() => {});
    });
  }
})();                      // ← discount IIFE closes here

/* ============================================
   CartRecommendations custom element
   Handles "+ Add" clicks on cart cross-sell items.
   Reads fully-qualified section IDs from data-id attributes
   so Shopify returns the full rendered section with blocks.
   ============================================ */
class CartRecommendations extends HTMLElement {
  constructor() {
    super();
    this.fetched = false;
  }

  connectedCallback() {
    // Show regular prices until the current cart has been checked.
    this.setRecommendationPricing(null);
    if (!window._cartRecsPricingBound && typeof subscribe === 'function' &&
        typeof PUB_SUB_EVENTS !== 'undefined') {
      window._cartRecsPricingBound = true;
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        fetch(`${window.Shopify.routes.root}cart.js`)
          .then((response) => {
            if (!response.ok) throw new Error('Unable to refresh recommendation pricing');
            return response.json();
          })
          .then((cart) => {
            document.querySelectorAll('cart-recommendations').forEach((element) => {
              element.setRecommendationPricing(cart);
            });
          })
          .catch((error) => console.warn('[cart-recommendations] pricing refresh failed', error));
      });
    }

    if (!window._cartRecsClickBound) {
      window._cartRecsClickBound = true;
      document.addEventListener('click', (e) => {
        const btn = e.target.closest('.cart-recommendations__add');
        if (btn && !btn.disabled) {
          e.preventDefault();
          CartRecommendations.handleAdd(btn);
        }
      });
    }

    if (!window._cartRecsOptionBound) {
      window._cartRecsOptionBound = true;
      document.addEventListener('change', (e) => {
        const sel = e.target.closest('.cart-recommendations__option-select');
        if (!sel) return;
        CartRecommendations.handleOptionChange(sel);
      });
    }

    this.initializeRecommendations();
  }

  async initializeRecommendations() {
    // Document carts use the requested pair instead of automatic suggestions.
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`);
      if (!response.ok) throw new Error('Unable to load cart recommendations context');
      const cart = await response.json();
      this.setRecommendationPricing(cart);
      const hasDocumentTrigger = (cart.items || []).some(
        (item) => item.handle === 'canada-customs-invoice-cci-fillable-auto-calculating-pdf' ||
          item.handle === 'usmca-cusma-certificate-of-origin-fillable-digital-pdf' ||
          item.handle === 'commercial-invoice-fillable-auto-calculating-pdf' ||
          item.handle === 'packing-list-fillable-auto-calculating-pdf'
      );
      if (hasDocumentTrigger) {
        this.fetched = true;
        this.replaceChildren();
        await this.renderFallbackRecommendations(cart);
        return;
      }
    } catch (error) {
      // Preserve the existing recommendation flow if the cart lookup fails.
      console.warn('[cart-recommendations] document check failed', error);
    }

    if (this.querySelector('.cart-recommendations__item')) {
      // Cards were server-rendered — filter, then fall back if all removed.
      (async () => {
        const anyLeft = await this.filterEligibleProducts();
        if (!anyLeft) {
          const innerEl = this.querySelector('.cart-recommendations__inner');
          if (innerEl) innerEl.remove();
          this.style.display = '';
          this.fetched = true;
          await this.renderFallbackRecommendations();
        } else {
          CartRecommendations.trackImpressions(this);
        }
      })();
      return;
    }

    this.fetchRecommendations();
  }

  fetchRecommendations() {
    const url = this.dataset.url;
    if (!url || this.fetched) return;
    this.fetched = true;

    // Try Shopify's recommendation API first; if empty, fall back to hand-picked mapping.
    fetch(url)
      .then((r) => r.text())
      .then(async (html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const inner = doc.querySelector('.cart-recommendations__inner');
        const hasCards = inner && inner.querySelector('.cart-recommendations__item');

        if (hasCards) {
          this.appendChild(inner);
          const anyLeft = await this.filterEligibleProducts();
          if (!anyLeft) {
            // Filter removed every card — try the hand-picked fallback instead.
            const innerEl = this.querySelector('.cart-recommendations__inner');
            if (innerEl) innerEl.remove();
            this.style.display = '';
            return this.renderFallbackRecommendations();
          }
          CartRecommendations.trackImpressions(this);
          return;
        }

        // No recommendations from Shopify — try the manual fallback.
        return this.renderFallbackRecommendations();
      })
      .catch((err) => {
        console.warn('[cart-recommendations] fetch failed', err);
        return this.renderFallbackRecommendations();
      });
  }

  setRecommendationPricing(cart) {
    // Display-only: Shopify remains responsible for actual discount allocation.
    const regularPrices = !cart || (cart.items || []).some((item) => {
      const price = item.final_price ?? item.price ?? item.original_price;
      return price != null && Number(price) === 0;
    });
    this.dataset.bpRegularPrices = String(regularPrices);

    if (!document.getElementById('bp-recommendation-price-mode')) {
      const style = document.createElement('style');
      style.id = 'bp-recommendation-price-mode';
      style.textContent = `
        cart-recommendations[data-bp-regular-prices="true"] .cart-recommendations__price--sale,
        cart-recommendations[data-bp-regular-prices="true"] [data-price-target],
        cart-recommendations[data-bp-regular-prices="true"] .cart-recommendations__badge,
        cart-recommendations[data-bp-regular-prices="true"] [data-badge-target] {
          display: none !important;
        }
        cart-recommendations[data-bp-regular-prices="true"] .cart-recommendations__price {
          display: inline !important;
          color: inherit;
        }
        cart-recommendations[data-bp-regular-prices="true"] .cart-recommendations__price,
        cart-recommendations[data-bp-regular-prices="true"] .cart-recommendations__price * {
          text-decoration: none !important;
        }
      `;
      document.head.appendChild(style);
    }
    this.updateRecommendationNote();
  }

  updateRecommendationNote() {
    const regularPrices = this.dataset.bpRegularPrices === 'true';
    this.querySelectorAll('.cart-recommendations__heading').forEach((heading) => {
      heading.textContent = regularPrices ? 'You May Also Need' : 'Bundle & Save';
    });
    const text = regularPrices
      ? 'Regular prices shown. Discounts apply only when your cart qualifies.'
      : '10% off applies to the lowest-priced eligible item in your cart.';
    this.querySelectorAll('.cart-recommendations__note').forEach((note) => {
      note.textContent = text;
    });
  }

  /**
   * When Shopify's recommendation API returns nothing, render hand-picked
   * bundle-eligible products based on what's in the cart.
   *
   * Trigger handles → recommended handles (rendered in order).
   * Digital cart items get digital recommendations; physical get physical.
   */
  async renderFallbackRecommendations(cartData = null) {
    // Map of trigger product handle → array of recommended product handles.
    // Document triggers take priority; otherwise use the first matching cart item.
    const FALLBACK_MAP = {
      // Packing List: physical PARS rolls and PAPS rolls.
      'packing-list-fillable-auto-calculating-pdf': [
        'pars-labels',
        'paps-labels'
      ],
      // Commercial Invoice: physical PARS rolls and PAPS rolls.
      'commercial-invoice-fillable-auto-calculating-pdf': [
        'pars-labels',
        'paps-labels'
      ],
      // USMCA / CUSMA Certificate: physical PAPS rolls and ACE lead sheets.
      'usmca-cusma-certificate-of-origin-fillable-digital-pdf': [
        'paps-labels',
        'ace-manifest-lead-sheets'
      ],
      // Canada Customs Invoice: physical PARS rolls and ACI lead sheets.
      'canada-customs-invoice-cci-fillable-auto-calculating-pdf': [
        'pars-labels',
        'aci-emanifest-lead-sheets'
      ],
      // ACE Manifest Lead Sheets (physical)
      'ace-manifest-lead-sheets': [
        'paps-labels-sheets',
        'ncap-fast-sheets',
        'aci-emanifest-lead-sheets'
      ],
      // ACE Manifest Lead Sheets (digital)
      'ace-manifest-lead-sheets-digital': [
        'paps-barcode-labels-digital-download',
        'ncap-fast-lead-sheets-digital-download',
        'aci-emanifest-lead-sheets-digital'
      ],
      // ACI eManifest Lead Sheets (physical)
      'aci-emanifest-lead-sheets': [
        'pars-labels-sheets',
        'csa-lead-sheet-cards',
        'ace-manifest-lead-sheets'
      ],
      // ACI eManifest Lead Sheets (digital)
      'aci-emanifest-lead-sheets-digital': [
        'pars-barcode-labels-digital-download',
        'csa-lead-sheet-cards',
        'ace-manifest-lead-sheets-digital'
      ],
      // Canada Cross-Border Kit (PARS + ACI)
      'canada-cross-border-kit': [
        'csa-lead-sheet-cards',
        'pars-barcode-labels-digital-download'
      ],
      // U.S. Cross-Border Kit (PAPS + ACE)
      'u-s-cross-border-kit': [
        'ncap-fast-sheets',
        'paps-barcode-labels-digital-download'
      ],
      // Complete Cross-Border Kit (PAPS/PARS + ACE/ACI)
      'complete-cross-border-kit': [
        'csa-lead-sheet-cards',
        'ncap-fast-sheets'
      ]
    };

    try {
      // Get cart items to find a matching trigger.
      const cart = cartData || await fetch(`${window.Shopify.routes.root}cart.js`).then((r) => r.json());
      this.setRecommendationPricing(cart);
      const cartHandles = (cart.items || []).map((i) => i.handle);

      // Document recommendations take priority, regardless of cart item order.
      // Packing List / Commercial Invoice use both rolls; otherwise USMCA precedes CCI.
      const packingListHandle = 'packing-list-fillable-auto-calculating-pdf';
      const commercialInvoiceHandle = 'commercial-invoice-fillable-auto-calculating-pdf';
      const invoiceHandle = 'canada-customs-invoice-cci-fillable-auto-calculating-pdf';
      const usmcaHandle = 'usmca-cusma-certificate-of-origin-fillable-digital-pdf';
      const triggerHandles = cartHandles.includes(packingListHandle) ? [packingListHandle] :
        cartHandles.includes(commercialInvoiceHandle) ? [commercialInvoiceHandle] :
        cartHandles.includes(usmcaHandle) ? [usmcaHandle] :
        cartHandles.includes(invoiceHandle) ? [invoiceHandle] : cartHandles;
      let recommendedHandles = null;
      for (const handle of triggerHandles) {
        if (FALLBACK_MAP[handle]) {
          // Exclude any handles already in the cart from recommendations.
          recommendedHandles = FALLBACK_MAP[handle].filter((h) => !cartHandles.includes(h));
          if (recommendedHandles.length) break;
        }
      }

      if (!recommendedHandles || !recommendedHandles.length) {
        this.style.display = 'none';
        return;
      }

      // Fetch each recommended product.
      const products = await Promise.all(
        recommendedHandles.slice(0, 2).map(async (handle) => {
          try {
            const resp = await fetch(`/products/${handle}.js`);
            if (!resp.ok) return null;
            return await resp.json();
          } catch (_) {
            return null;
          }
        })
      );

      const valid = products.filter((p) => p && p.available !== false);
      if (!valid.length) {
        this.style.display = 'none';
        return;
      }

      // Build the inner wrapper + cards.
      const inner = document.createElement('div');
      inner.className = 'cart-recommendations__inner';
      inner.innerHTML = '<h3 class="cart-recommendations__heading">Bundle &amp; Save</h3>' +
        '<p class="cart-recommendations__note" style="font-size:12px;color:#666;margin:-4px 0 12px;line-height:1.4;">10% off applies to the lowest-priced eligible item in your cart.</p>';

      const ul = document.createElement('ul');
      ul.className = 'cart-recommendations__grid';
      ul.setAttribute('role', 'list');

      valid.forEach((product) => {
        const variant = (product.variants || []).find((v) => v.available) || product.variants[0];
        if (!variant) return;

        const originalPrice = variant.price; // cents
        const salePrice = Math.round(originalPrice * 0.9);
        const discountAmount = originalPrice - salePrice;
        const productUrl = product.url || `/products/${product.handle}`;
        const image = product.featured_image || (product.images && product.images[0]) || '';
        const imageUrl = image ? (typeof image === 'string' ? image : image.src || '') : '';

        const li = document.createElement('li');
        li.className = 'cart-recommendations__item';
        li.dataset.productHandle = product.handle;
        li.dataset.productId = product.id;

        li.innerHTML = `
          <a href="${productUrl}" class="cart-recommendations__image-link" aria-label="${this._esc(product.title)}">
            ${imageUrl ? `<img src="${imageUrl}" alt="${this._esc(product.title)}" loading="lazy" width="160" height="160" class="cart-recommendations__image">` : ''}
          </a>
          <div class="cart-recommendations__body">
            <a href="${productUrl}" class="cart-recommendations__title">${this._esc(product.title)}</a>
            <div class="cart-recommendations__price-row">
              <div class="cart-recommendations__price-wrap">
                <span class="cart-recommendations__price">${this._money(originalPrice)}</span>
                <span class="cart-recommendations__price--sale" data-price-target data-full-price="${originalPrice}">${this._money(salePrice)}</span>
              </div>
              <span class="cart-recommendations__badge" data-badge-target>Get 10% Off — Save ${this._money(discountAmount)}</span>
            </div>
          </div>
          <button type="button" class="cart-recommendations__add"
                  data-variant-id="${variant.id}"
                  data-product-title="${this._esc(product.title)}"
                  aria-label="Add ${this._esc(product.title)} to cart">
            + Add
          </button>
        `;

        ul.appendChild(li);
      });

      inner.appendChild(ul);
      inner.style.visibility = 'visible';
      this.style.visibility = 'visible';
      this.style.display = '';
      this.appendChild(inner);
      this.updateRecommendationNote();
      // Force any child cards to visible too, in case CSS hides them.
      this.querySelectorAll('.cart-recommendations__item').forEach((c) => { c.style.visibility = 'visible'; });
      CartRecommendations.trackImpressions(this);
    } catch (err) {
      console.warn('[cart-recommendations] fallback failed', err);
      this.style.display = 'none';
    }
  }

  _esc(str) {
    return String(str || '').replace(/[&<>"']/g, (c) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[c]));
  }

  _money(cents) {
    const dollars = (cents / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'
    });
    return dollars;
  }

  async filterEligibleProducts() {
    const REQUIRED_TAG = 'bundle-eligible';
    const cards = this.querySelectorAll('.cart-recommendations__item');
    if (!cards.length) return;

    // Hide everything up-front to prevent flash of unfiltered content
    const inner = this.querySelector('.cart-recommendations__inner') || this;
    inner.style.visibility = 'hidden';

    await Promise.all(Array.from(cards).map(async (card) => {
      const link = card.querySelector('a[href*="/products/"]');
      const url = (link && link.getAttribute('href')) || card.dataset.productUrl || '';
      const match = url.match(/\/products\/([^/?#]+)/);
      if (!match) return;
      const handle = match[1];

      try {
        const resp = await fetch(`/products/${handle}.js`);
        if (!resp.ok) return;
        const product = await resp.json();
        const tags = (product.tags || []).map((t) => String(t).toLowerCase());
        if (!tags.includes(REQUIRED_TAG)) {
          card.remove();
        }
      } catch (_) { /* ignore */ }
    }));

    // Cap to 2 recommended cards max.
    const kept = this.querySelectorAll('.cart-recommendations__item');
    for (let i = 2; i < kept.length; i++) kept[i].remove();

    // Return whether any eligible cards remain, so caller can decide fallback.
    const remaining = this.querySelectorAll('.cart-recommendations__item').length;
    if (!remaining) {
      this.style.display = 'none';
      return false;
    }
    // Inject Bundle & Save disclaimer if not already present.
    if (!inner.querySelector('.cart-recommendations__note')) {
      const note = document.createElement('p');
      note.className = 'cart-recommendations__note';
      note.style.cssText = 'font-size:12px;color:#666;margin:-4px 0 12px;line-height:1.4;';
      note.textContent = '10% off applies to the lowest-priced eligible item in your cart.';
      const heading = inner.querySelector('.cart-recommendations__heading');
      if (heading && heading.nextSibling) {
        inner.insertBefore(note, heading.nextSibling);
      } else if (heading) {
        heading.after(note);
      } else {
        inner.prepend(note);
      }
    }
    this.updateRecommendationNote();
    inner.style.visibility = 'visible';
    return true;
  }

  static getSectionsToRender() {
    // Read the ACTUAL section IDs from data-id attributes on the live DOM.
    // Shopify needs the full template-qualified ID (e.g. "template--123__cart-footer")
    // to correctly render the section with its block configuration.
    const sections = [];

    const itemsEl = document.querySelector('#main-cart-items');
    if (itemsEl && itemsEl.dataset.id) {
      sections.push({ section: itemsEl.dataset.id, selector: '#main-cart-items' });
    }

    const footerEl = document.querySelector('#main-cart-footer');
    if (footerEl && footerEl.dataset.id) {
      sections.push({ section: footerEl.dataset.id, selector: '#main-cart-footer' });
    }

    const iconEl = document.querySelector('#cart-icon-bubble');
    if (iconEl) {
      // Cart icon bubble is a snippet, no data-id — use bare name
      sections.push({ section: 'cart-icon-bubble', selector: '#cart-icon-bubble' });
    }

    return sections;
  }

  static handleAdd(btn) {
    const variantId = btn.dataset.variantId;
    const productTitle = btn.dataset.productTitle;
    if (!variantId) return;

    btn.disabled = true;
    const originalText = btn.textContent;
    btn.textContent = 'Adding...';

    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'cross_sell_add_click',
        product_title: productTitle,
        variant_id: variantId,
        source: 'cart'
      });
    }

    const sectionsToRender = CartRecommendations.getSectionsToRender();
    const sectionNames = sectionsToRender.map((s) => s.section);

    fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript'
      },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1 }],
        sections: sectionNames,
        sections_url: window.location.pathname
      })
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.status && data.status !== 200) {
          throw new Error(data.description || data.message || 'Add to cart failed');
        }

        if (data.sections) {
          CartRecommendations.updateSections(data.sections, sectionsToRender);
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'cart-recommendations',
            productVariantId: variantId
          });
        }

        return CartRecommendations.applyBundleDiscountCode()
          .then(() => CartRecommendations.checkBundleApplied());
      })
      .catch((err) => {
        console.error('[cart-recommendations] add failed', err);
        try {
          btn.textContent = originalText;
          btn.disabled = false;
        } catch (e) { /* button was removed */ }
        alert(`Couldn't add ${productTitle || 'item'} to cart. Please try again.`);
      });
  }

  static updateSections(sectionsData, sectionsToRender) {
    sectionsToRender.forEach(({ section, selector }) => {
      const sectionHtml = sectionsData[section];
      if (!sectionHtml) {
        console.warn(`[cart-recommendations] no HTML returned for section ${section}`);
        return;
      }

      const currentElement = document.querySelector(selector);
      if (!currentElement) {
        console.warn(`[cart-recommendations] no element in DOM for ${selector}`);
        return;
      }

      const parser = new DOMParser();
      const doc = parser.parseFromString(sectionHtml, 'text/html');
      const newElement = doc.querySelector(selector);

      if (newElement) {
        currentElement.innerHTML = newElement.innerHTML;
      } else {
        // Cart icon bubble is inline HTML with no wrapping element — use body content
        if (selector === '#cart-icon-bubble') {
          currentElement.innerHTML = doc.body.innerHTML.trim();
        } else {
          console.warn(`[cart-recommendations] no matching ${selector} in returned HTML`);
        }
      }
    });
  }

  static applyBundleDiscountCode() {
    const CODE = 'BUNDLESAVE10';

    // Skip if the code is already on the cart
    return fetch(`${window.Shopify.routes.root}cart.js`)
      .then((r) => r.json())
      .then((cart) => {
        const applied = (cart.cart_level_discount_applications || [])
          .concat((cart.items || []).flatMap((i) => i.discounts || []))
          .some((d) => (d.title || '').toUpperCase() === CODE);
        if (applied) return;

        // Only apply if cart has 2+ items (matches the discount's threshold)
        if ((cart.item_count || 0) < 2) return;

        return new Promise((resolve) => {
          const frame = document.createElement('iframe');
          frame.setAttribute('aria-hidden', 'true');
          frame.style.cssText = 'position:absolute;left:-9999px;top:-9999px;width:1px;height:1px;border:0;';
          frame.src = '/discount/' + encodeURIComponent(CODE) + '?redirect=/cart';

          let done = false;
          const finish = () => {
            if (done) return;
            done = true;
            setTimeout(() => { try { frame.remove(); } catch (_) {} }, 200);
            resolve();
          };

          frame.addEventListener('load', finish, { once: true });
          setTimeout(finish, 6000);
          document.body.appendChild(frame);
        }).then(() => {
          // Mark this visit so the cleaner IIFE doesn't strip the code
          try { sessionStorage.setItem('bp_promo_applied_this_visit', '1'); } catch (_) {}

          // Re-fetch cart sections so subtotal + line prices reflect the discount
          const sectionsToRender = CartRecommendations.getSectionsToRender();
          const sectionNames = sectionsToRender.map((s) => s.section);
          if (!sectionNames.length) return;

          return fetch(`${window.Shopify.routes.root}?sections=${sectionNames.join(',')}`)
            .then((r) => r.json())
            .then((data) => CartRecommendations.updateSections(data, sectionsToRender));
        });
      })
      .catch((err) => console.warn('[cart-recommendations] discount apply failed', err));
  }

  static checkBundleApplied() {
    return fetch(`${window.Shopify.routes.root}cart.js`)
      .then((r) => r.json())
      .then((cart) => {
        const isBundle = (d) =>
          d && d.title && d.title.toLowerCase().includes('bundle');

        // Prefer cart-level discount if present — it's already the total.
        const cartLevel = (cart.cart_level_discount_applications || []).find(isBundle);

        let totalCents = 0;

        if (cartLevel) {
          totalCents =
            cartLevel.total_allocated_amount ||
            cartLevel.amount ||
            0;
        } else {
          // Otherwise sum per-line allocations across every line, once per line.
          (cart.items || []).forEach((item) => {
            const lineBundle = (item.discounts || []).find(isBundle);
            if (lineBundle) {
              totalCents += lineBundle.amount || 0;
            }
          });
        }

        if (totalCents > 0) {
          CartRecommendations.showBundleCallout(totalCents);
          if (window.dataLayer) {
            window.dataLayer.push({
              event: 'bundle_discount_applied',
              amount: totalCents / 100
            });
          }
        }
      })
      .catch((err) => console.warn('[cart-recommendations] bundle check failed', err));
  }

  static showBundleCallout(amountCents) {
    const totals = document.querySelector('.totals');
    if (!totals) return;

    const existing = document.querySelector('.cart-bundle-applied');
    if (existing) existing.remove();

    const callout = document.createElement('div');
    callout.className = 'cart-bundle-applied';
    const dollars = (amountCents / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    });
    callout.innerHTML = `<span>Bundle discount applied — you saved ${dollars}</span>`;
    totals.parentNode.insertBefore(callout, totals);
  }

    static handleOptionChange(sel) {
    const item = sel.closest('.cart-recommendations__item');
    if (!item) return;
    const wrapper = item.querySelector('.cart-recommendations__options');
    const btn = item.querySelector('.cart-recommendations__add');
    if (!wrapper || !btn) return;

    const productUrl = wrapper.dataset.productUrl;
    let baseOptions;
    try {
      baseOptions = JSON.parse(wrapper.dataset.currentOptions);
    } catch (_) {
      baseOptions = [];
    }

    const selects = wrapper.querySelectorAll('.cart-recommendations__option-select');
    const target = baseOptions.slice();
    selects.forEach((s) => {
      target[parseInt(s.dataset.optionIndex, 10)] = s.value;
    });

    selects.forEach((s) => { s.disabled = true; });
    btn.disabled = true;

    fetch(`${productUrl}.js`)
      .then((r) => r.json())
      .then((product) => {
        const match = (product.variants || []).find((v) => {
          const opts = v.options || [];
          return opts.length === target.length &&
                 opts.every((val, i) => val === target[i]);
        });

        if (!match) throw new Error('No matching variant');

        btn.dataset.variantId = match.id;
        CartRecommendations.updatePriceDisplay(item, match.price);

        if (!match.available) {
          btn.textContent = 'Sold out';
          btn.disabled = true;
          btn.classList.add('is-sold-out');
        } else {
          btn.textContent = '+ Add';
          btn.disabled = false;
          btn.classList.remove('is-sold-out');
        }

        wrapper.dataset.currentOptions = JSON.stringify(match.options);
      })
      .catch((err) => {
        console.warn('[cart-recommendations] option resolve failed', err);
        btn.textContent = 'Unavailable';
        btn.disabled = true;
      })
      .finally(() => {
        selects.forEach((s) => { s.disabled = false; });
      });
  }

  static updatePriceDisplay(item, priceCents) {
    const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    const fmt = (cents) => (cents / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: currency
    });

    const originalEl = item.querySelector('.cart-recommendations__price');
    if (originalEl) {
      originalEl.textContent = fmt(priceCents);
      originalEl.dataset.fullPrice = String(priceCents);
    }

    const discountCents = Math.round(priceCents * 0.1);
    const saleCents = priceCents - discountCents;
    const saleEl = item.querySelector('[data-price-target]') ||
                   item.querySelector('.cart-recommendations__price--sale');
    if (saleEl) {
      saleEl.textContent = fmt(saleCents);
      saleEl.dataset.fullPrice = String(priceCents);
    }

    const badge = item.querySelector('[data-badge-target]') ||
                  item.querySelector('.cart-recommendations__badge');
    if (badge) {
      badge.textContent = `Get 10% Off — Save ${fmt(discountCents)}`;
    }
  }

  static trackImpressions(el) {
    const items = el.querySelectorAll('.cart-recommendations__item');
    if (!window.dataLayer || items.length === 0) return;
    window.dataLayer.push({
      event: 'cross_sell_impression',
      source: 'cart',
      product_count: items.length,
      products: Array.from(items).map((item) => item.dataset.productHandle)
    });
  }
}

if (!customElements.get('cart-recommendations')) {
  customElements.define('cart-recommendations', CartRecommendations);
}

/* ============================================
   Cart line-item option switcher (Dawn)
   Uses /cart/change.js with `line` index for reliable
   in-place replacement, then re-renders via
   cart-items element's section list.
   ============================================ */
(function () {
  if (window._cartOptionSwitchBound) return;
  window._cartOptionSwitchBound = true;

  document.addEventListener('change', function (e) {
    const sel = e.target.closest('.cart-item__option-select');
    if (!sel) return;
    swapCartOption(sel);
  });

  function getCartItemsElement() {
    return document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
  }

  function getSectionsToRender() {
    const el = getCartItemsElement();
    if (el && typeof el.getSectionsToRender === 'function') {
      return el.getSectionsToRender();
    }
    // Fallback: mirror CartRecommendations
    const out = [];
    const itemsEl = document.querySelector('#main-cart-items');
    if (itemsEl && itemsEl.dataset.id) {
      out.push({ id: 'main-cart-items', section: itemsEl.dataset.id, selector: '.js-contents' });
    }
    const footerEl = document.querySelector('#main-cart-footer');
    if (footerEl && footerEl.dataset.id) {
      out.push({ id: 'main-cart-footer', section: footerEl.dataset.id, selector: '.js-contents' });
    }
    const iconEl = document.querySelector('#cart-icon-bubble');
    if (iconEl) {
      out.push({ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });
    }
    return out;
  }

  function getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  function swapCartOption(sel) {
    const oldKey = sel.dataset.lineKey;
    const qty = parseInt(sel.dataset.quantity, 10) || 1;
    const productUrl = sel.dataset.productUrl;

    // Build target combo from every sibling select on this line
    const line = sel.closest('.cart-item');
    if (!line) return;
    const allSelects = line.querySelectorAll('.cart-item__option-select');
    let baseOptions;
    try {
      baseOptions = JSON.parse(sel.dataset.currentOptions);
    } catch (_) {
      baseOptions = [];
    }
    const target = baseOptions.slice();
    allSelects.forEach((s) => {
      target[parseInt(s.dataset.optionIndex, 10)] = s.value;
    });

    // Line index (1-based) — Dawn line items have id="CartItem-N"
    const rowId = line.getAttribute('id') || '';
    const lineIndex = parseInt(rowId.replace('CartItem-', ''), 10);
    if (!lineIndex) {
      console.warn('[cart-option-switch] no line index found on', line);
      return;
    }

    // Holds line-item properties (personalization) + selling plan across the swap
    let preservedProperties = {};

    allSelects.forEach((s) => { s.disabled = true; });

    // Show Dawn's loading spinner on this row if it exists
    const spinner = line.querySelector('.loading-overlay');
    if (spinner) spinner.classList.remove('hidden');

    // 0) Snapshot the current cart to preserve this line's properties + selling_plan
    fetch(`${window.Shopify.routes.root}cart.js`)
      .then((r) => r.json())
      .then((cart) => {
        const currentLine = (cart.items || [])[lineIndex - 1];
        if (currentLine) {
          if (currentLine.properties && typeof currentLine.properties === 'object') {
            preservedProperties = Object.assign({}, currentLine.properties);
          }
          if (currentLine.selling_plan_allocation && currentLine.selling_plan_allocation.selling_plan) {
            preservedProperties.__sellingPlan = currentLine.selling_plan_allocation.selling_plan.id;
          }
        }
      })
      .catch(() => { /* non-fatal, continue without props */ })
      // 1) Resolve the target variant
      .then(() => fetch(`${productUrl}.js`))
      .then((r) => r.json())
      .then((product) => {
        const match = (product.variants || []).find((v) => {
          const opts = v.options || [];
          return opts.length === target.length &&
                 opts.every((val, i) => val === target[i]);
        });
        if (!match) throw new Error('No matching variant');
        if (!match.available) throw new Error('That combination is sold out');
        return match.id;
      })
      // 2) Remove the old line by index
      .then((newVariantId) => {
        const sectionsToRender = getSectionsToRender();
        const sectionNames = sectionsToRender.map((s) => s.section);

        // Pull the selling plan out before spreading properties onto the add payload
        const sellingPlanId = preservedProperties.__sellingPlan;
        delete preservedProperties.__sellingPlan;

        const addItem = { id: newVariantId, quantity: qty };
        if (Object.keys(preservedProperties).length > 0) {
          addItem.properties = preservedProperties;
        }
        if (sellingPlanId) {
          addItem.selling_plan = sellingPlanId;
        }

        return fetch(`${window.Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            line: lineIndex,
            quantity: 0,
            sections: sectionNames,
            sections_url: window.location.pathname
          })
        })
          .then((r) => r.json())
          // 3) Add the new variant at the same qty (also asking for sections back)
          .then(() =>
            fetch(`${window.Shopify.routes.root}cart/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                items: [addItem],
                sections: sectionNames,
                sections_url: window.location.pathname
              })
            })
          )
          .then((r) => r.json())
          .then((data) => ({ data, sectionsToRender }));
      })
      .then(({ data, sectionsToRender }) => {
        if (data.status && data.status !== 200) {
          throw new Error(data.description || data.message || 'Add failed');
        }
        if (!data.sections) return;

        // Re-render each section using Dawn's inner-selector pattern
        sectionsToRender.forEach(({ id, section, selector }) => {
          const container = document.getElementById(id);
          if (!container) return;
          const sectionHtml = data.sections[section];
          if (!sectionHtml) return;
          const targetEl = container.querySelector(selector) || container;
          try {
            targetEl.innerHTML = getSectionInnerHTML(sectionHtml, selector);
          } catch (_) {
            // If selector isn't in the returned HTML, fall back to full body
            const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
            const el = doc.querySelector('#' + id);
            targetEl.innerHTML = el ? el.innerHTML : doc.body.innerHTML.trim();
          }
        });

        // Notify the theme so mini-cart, totals, header bubble, etc. refresh
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'variant-switch' });
        }

        if (window.dataLayer) {
          window.dataLayer.push({ event: 'cart_variant_changed' });
        }

        // Re-check bundle callout after the swap
        if (typeof CartRecommendations !== 'undefined' && CartRecommendations.checkBundleApplied) {
          CartRecommendations.checkBundleApplied();
        }
      })
      .catch((err) => {
        console.error('[cart-option-switch] failed', err);
        alert(err.message === 'That combination is sold out'
          ? "Sorry, that combination is sold out."
          : "Couldn't change the option. Please try again.");
        if (spinner) spinner.classList.add('hidden');
        allSelects.forEach((s) => { s.disabled = false; });
      });
  }
})();

/* ==========================================================================
   Global cart-empty discount clearer
   Runs on every page — when the cart hits 0 items via any surface (cart page,
   drawer, PDP remove-last, etc.), clear the session-level discount code so
   re-adding an item does NOT auto-restore the previous promo.
   ========================================================================== */
(function () {
  if (typeof window === 'undefined') return;
  if (!window.Shopify || !Shopify.routes) return;

  function clearSessionDiscount() {
    const f = document.createElement('iframe');
    f.style.cssText = 'position:absolute;left:-9999px;width:1px;height:1px;border:0;';
    f.src = '/discount/?redirect=' + encodeURIComponent(window.location.pathname || '/');
    f.addEventListener('load', () => {
      setTimeout(() => { try { f.remove(); } catch (_) {} }, 150);
    }, { once: true });
    document.body.appendChild(f);
  }

  function checkAndClearIfEmpty() {
    fetch(`${Shopify.routes.root}cart.js`)
      .then((r) => r.json())
      .then((cart) => {
        if (cart && cart.item_count === 0) clearSessionDiscount();
      })
      .catch(() => {});
  }

  // Subscribe to Dawn's cart pub/sub if available
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      // Small delay so cart.js reflects the latest state
      setTimeout(checkAndClearIfEmpty, 100);
    });
  }

  // Fallback: intercept /cart/change.js and /cart/update.js responses in case
  // an app or custom code doesn't publish through Dawn's pub/sub.
  const _fetch = window.fetch;
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const isCartMutation = /\/cart\/(change|update|clear)\.js/.test(url);
    const p = _fetch.apply(this, arguments);
    if (isCartMutation) {
      p.then(() => setTimeout(checkAndClearIfEmpty, 100)).catch(() => {});
    }
    return p;
  };
})();

/* ==========================================================================
   Aggressive session-discount clearer.
   Runs on the cart page. If any discount code is applied but the shopper
   did NOT apply one this visit (i.e. it's a stale session-cached code from
   a prior visit), strip it. Uses two methods for reliability.
   ========================================================================== */
(function () {
  if (typeof window === 'undefined') return;
  if (!window.Shopify || !Shopify.routes) return;

  // Only on cart page
  if (!/\/cart(\?|$|\/)/.test(window.location.pathname + window.location.search)) return;

  const APPLIED_KEY = 'bp_promo_applied_this_visit';

  // Was a code applied this visit? (Set by the Apply handler in the discount IIFE.)
  let appliedThisVisit = false;
  try { appliedThisVisit = sessionStorage.getItem(APPLIED_KEY) === '1'; } catch (_) {}

  if (appliedThisVisit) return;

  fetch(`${Shopify.routes.root}cart.js`)
    .then((r) => r.json())
    .then((cart) => {
      const hasCode =
        (cart.cart_level_discount_applications || []).some((d) => d.type === 'discount_code') ||
        (cart.items || []).some((i) =>
          (i.discounts || []).some((d) => d.type === 'discount_code')
        );
      if (!hasCode) return;

      // Method 1: POST /cart/update.js with discount_codes: []
      return fetch(`${Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount_codes: [] })
      })
        .then(() => fetch(`${Shopify.routes.root}cart.js`))
        .then((r) => r.json())
        .then((c2) => {
          const stillHas =
            (c2.cart_level_discount_applications || []).some((d) => d.type === 'discount_code') ||
            (c2.items || []).some((i) =>
              (i.discounts || []).some((d) => d.type === 'discount_code')
            );

          if (!stillHas) {
            // Success — reload to re-render with correct prices
            window.location.reload();
            return;
          }

          // Method 2: Overwrite session code with a nonsense code
          const nonsense = 'CLEAR_' + Date.now();
          const frame = document.createElement('iframe');
          frame.style.cssText = 'position:absolute;left:-9999px;width:1px;height:1px;border:0;';
          frame.src = '/discount/' + encodeURIComponent(nonsense) + '?redirect=/cart';
          frame.addEventListener('load', () => {
            setTimeout(() => {
              try { frame.remove(); } catch (_) {}
              window.location.reload();
            }, 300);
          }, { once: true });
          setTimeout(() => {
            try { frame.remove(); } catch (_) {}
            window.location.reload();
          }, 5000);
          document.body.appendChild(frame);
        });
    })
    .catch(() => {});
})();

/* ==========================================================================
   Auto-remove BUNDLESAVE10 when no bundle-eligible items remain in cart.
   Runs on every cart mutation. If BUNDLESAVE10 is in the session but the
   cart no longer contains any bundle-eligible products, silently strip it.
   ========================================================================== */
(function () {
  if (typeof window === 'undefined') return;
  if (!window.Shopify || !Shopify.routes) return;

  const CODE = 'BUNDLESAVE10';
  const REQUIRED_TAG = 'bundle-eligible';
  const eligibilityCache = new Map();

  async function isEligible(handle) {
    if (!handle) return false;
    if (eligibilityCache.has(handle)) return eligibilityCache.get(handle);
    try {
      const resp = await fetch(`/products/${handle}.js`);
      if (!resp.ok) {
        eligibilityCache.set(handle, false);
        return false;
      }
      const product = await resp.json();
      const tags = (product.tags || []).map((t) => String(t).toLowerCase());
      const eligible = tags.includes(REQUIRED_TAG);
      eligibilityCache.set(handle, eligible);
      return eligible;
    } catch (_) {
      eligibilityCache.set(handle, false);
      return false;
    }
  }

  async function cartHasEligibleItem() {
    const cart = await fetch(`${Shopify.routes.root}cart.js`).then((r) => r.json());
    if (!cart.items || !cart.items.length) return false;
    const checks = await Promise.all(cart.items.map((i) => isEligible(i.handle)));
    return checks.some(Boolean);
  }

  async function isCodeApplied() {
    const cart = await fetch(`${Shopify.routes.root}cart.js`).then((r) => r.json());
    const titles = (cart.cart_level_discount_applications || [])
      .concat((cart.items || []).flatMap((i) => i.discounts || []))
      .map((d) => (d.title || '').toUpperCase());
    return titles.includes(CODE);
  }

  function clearCode() {
    return new Promise((resolve) => {
      const nonsense = 'CLEAR_' + Date.now();
      const frame = document.createElement('iframe');
      frame.setAttribute('aria-hidden', 'true');
      frame.style.cssText = 'position:absolute;left:-9999px;top:-9999px;width:1px;height:1px;border:0;';
      frame.src = '/discount/' + encodeURIComponent(nonsense) + '?redirect=/cart';
      let done = false;
      const finish = () => {
        if (done) return;
        done = true;
        setTimeout(() => { try { frame.remove(); } catch (_) {} }, 200);
        try { sessionStorage.removeItem('bp_promo_applied_this_visit'); } catch (_) {}
        resolve();
      };
      frame.addEventListener('load', finish, { once: true });
      setTimeout(finish, 5000);
      document.body.appendChild(frame);
    });
  }

  async function checkAndCleanup() {
    try {
      const applied = await isCodeApplied();
      if (!applied) return;
      const stillEligible = await cartHasEligibleItem();
      if (stillEligible) return;

      await clearCode();

      // If on cart page, reload so the pricing app + subtotal refresh cleanly
      if (/\/cart(\?|$|\/)/.test(window.location.pathname + window.location.search)) {
        window.location.reload();
      }
    } catch (err) {
      console.warn('[bundle-cleanup] failed', err);
    }
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => setTimeout(checkAndCleanup, 200));
  }

  // Fallback: intercept fetch to catch any non-Dawn cart mutation path
  const _fetch = window.fetch;
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const isMut = /\/cart\/(change|update|clear)\.js/.test(url);
    const p = _fetch.apply(this, arguments);
    if (isMut) p.then(() => setTimeout(checkAndCleanup, 250)).catch(() => {});
    return p;
  };
})();
